import { useEffect } from 'react';
import { brand } from '../brand/brand';

/**
 * Sets the document title for a route.
 *
 * WHY IT MATTERS BEYOND THE BROWSER TAB
 *
 * A single-page app does not reload, so the title never changes on its own and
 * every page reads as the bare product name in history, in bookmarks, and — the
 * part that actually matters — in the announcement a screen reader makes after
 * navigation. Someone using one has no other cue that the page changed at all.
 *
 * (The name is not written out even in this comment: BrandLeakTests fails the
 * build on the literal appearing anywhere outside brand/brand.json, and a comment
 * is exactly where a stale product name survives a rename.)
 *
 * Pass null while the page is still loading its subject, so a title does not flash
 * "Undefined" before the real one arrives.
 *
 * The product name comes from brand.json, like everywhere else. BrandLeakTests
 * fails the build on a literal.
 */
export function usePageTitle(title: string | null): void {
  useEffect(() => {
    document.title = title === null || title === ''
      ? `${brand.name} — ${brand.tagline}`
      : `${title} — ${brand.name}`;
  }, [title]);
}
